import React from 'react'

import { withUserStore } from '../../contexts/UserStore'
import { withModals } from '../../contexts/modals'
import ButtonsView from './ButtonsView'

// Responsive tile grid. reactstrap Col breakpoints (xl3/lg4/md6/sm12) become a
// Tailwind grid under `.cbs-scope`: 1 col → 2 (md) → 3 (lg) → 4 (xl). Custom app
// classes (padding5, aspect4-3, …) are global and unchanged. (#635)
const TileView = ({ entries, modalActions, recordType, userStore }) => {
  const click = (e, entry) => {
    e.stopPropagation()
    if (entry.click) entry.click(entry.editModal.formRecord)
    if (entry.clickModal) modalActions.openModal(entry.clickModal)
    if (entry.clickUrl) userStore.appNavigate(entry.clickUrl)
  }

  return (
    <div className="cbs-scope full-width margin-top">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
        {entries.map((entry, index) => (
          <div className="padding5" key={index}>
            <div
              onClick={(e) => click(e, entry)}
              className="margin10 border3 rounded05 padding10 aspect4-3 hover relative"
            > {entry.el}
              <ButtonsView type={recordType} entry={entry} index={index} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withUserStore(withModals(TileView))
